import Cookies from 'js-cookie';

export default {
    classType: 'components',

    init() {
        // If we did not already asked the user and they are not connected
        let isCookieCurrencySwitchSet = Cookies.get('currency-has-been-set');
        if (!(appData.user && appData.user.id) && !isCookieCurrencySwitchSet) {
            // After a while, display the currency switch box
            setTimeout(() => {
                // Get the box and display it
                let box = document.getElementById('currency-switcher');
                box.classList.add('currency-switcher-shown');

                // Get the cancel button and make it create a cookie
                // to save user's choice
                document
                    .getElementById('currency-switch-suggestion-cancel')
                    .addEventListener('click', () => {
                        Cookies.set('currency-has-been-set', true);
                        box.classList.remove('currency-switcher-shown');
                    });
                // Get the modal submit button and make it create a cookie
                // to save user's choice
                document
                    .getElementById('currency-switch-suggestion-choose')
                    .addEventListener('click', () => {
                        Cookies.set('currency-has-been-set', true);
                        box.classList.remove('currency-switcher-shown');
                    });
            }, 2500);
        }
    },
};
